import React from 'react';
import { Button } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

const FloatingButton = ({onClick}) => {

  return (
    <Button
      type="primary"
      shape="circle"
      icon={<EllipsisOutlined />}
      size="large"
      style={{
        position: 'fixed',
        bottom: '86px',
        right: '24px',
        zIndex: 1000,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}
      onClick={onClick}
    />
  );
};

export default FloatingButton;
